/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleProvisioningControllerListRecordsQueryResponse, TrimbleProvisioningControllerListRecordsQueryParams, TrimbleProvisioningControllerListRecords401, TrimbleProvisioningControllerListRecords403 } from "../../models/trimbleProvisioningController/TrimbleProvisioningControllerListRecords";

function getTrimbleProvisioningControllerListRecordsUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble-provisioning-records` as const }  
  return res
}

/**
 * @summary List organizations provisioned from Trimble EMS entitlement events
 * {@link /api/v1/trimble-provisioning-records}
 */
export async function trimbleProvisioningControllerListRecords(params?: TrimbleProvisioningControllerListRecordsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleProvisioningControllerListRecordsQueryResponse, ResponseErrorConfig<TrimbleProvisioningControllerListRecords401 | TrimbleProvisioningControllerListRecords403>, unknown>({ method : "GET", url : getTrimbleProvisioningControllerListRecordsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}